import Vue from "vue";
import { LMap, LTileLayer, LControl, LPopup } from "vue2-leaflet";
import { mdiChevronRight, mdiFullscreen, mdiFullscreenExit } from "@mdi/js";
import EoMapIcon from "@/components/MapIcon";
import getGoogleRouteLinkForAddress from "@/lib/get-google-route-link-for-address";
import fullscreen from "vue-fullscreen";
import "./DetailMap.sass";
import "leaflet/dist/leaflet.css";

Vue.use(fullscreen);

export default {
  name: "eo-detail-map",
  props: {
    event: {
      type: Object,
      required: true
    },
    settings: {
      type: Object,
      required: true
    },
    address: {
      type: String
    },
    widgetWidth: {
      type: Number
    }
  },
  components: {
    LMap,
    LTileLayer,
    LControl,
    LPopup,
    EoMapIcon
  },
  data() {
    return {
      isFullScreen: false,
      isMapIconActive: false,
      url: this.settings.tileServer?.url?.length
        ? this.settings.tileServer.url
        : "https://maps.api.eo-heimat.de/tiles/osm-bright/",
      tileParams:
        this.settings.tileServer?.params ||
        `?apiKey=${this.settings.apiKey}`,
      attribution: this.settings?.tileServer?.attribution?.length
        ? this.settings.tileServer.attribution
        : 'Powered by <a href="https://www.geoapify.com/">Geoapify</a>|\n<a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>|\n<a href="http://openmaptiles.org/" target="_blank">© OpenMapTiles</a>',
      mapObject: undefined,
      // icons
      mdiChevronRight: mdiChevronRight,
      mdiFullscreen: mdiFullscreen,
      mdiFullscreenExit: mdiFullscreenExit,
      height: 360
    };
  },
  computed: {
    street() {
      return this.event &&
        this.event.location &&
        this.event.location.address &&
        this.event.location.address.address
        ? this.event.location.address.address
        : "";
    },
    routeAddress() {
      return this.event && this.event.location
        ? getGoogleRouteLinkForAddress(this.event.location.address)
        : undefined;
    }
  },
  mounted() {
    this.mapObject = this.$refs.myDetailMap.mapObject;
    // disable zooming
    this.mapObject.scrollWheelZoom.disable();
    // disable dragging
    this.mapObject.dragging.disable();
    // invalidate size - load map correctly in some T3 instances
    this.mapObject.invalidateSize(false);

    window.addEventListener("resize", this.setMapHeight);
    setInterval(this.setMapHeight, 1000);
  },
  methods: {
    setMapHeight() {
      this.height = this.$refs?.mapWrapper?.clientWidth / (16 / 9);
      this.mapObject.invalidateSize(true);
    },
    fullScreenToggle() {
      const elem = this.$refs.myDetailMap.$el;

      this.$fullscreen.toggle(elem, {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(isFullScreen) {
      this.isFullScreen = isFullScreen;

      // change draggable
      if (isFullScreen) {
        this.mapObject.dragging.enable();
        this.mapObject.scrollWheelZoom.enable();
      } else {
        this.mapObject.dragging.disable();
        this.mapObject.scrollWheelZoom.disable();
        // invalidate size
        this.mapObject.invalidateSize(false);
        // re-center map
        if (this.poi?.geo)
          this.mapObject.panTo({
            lon: this.poi.geo.lng,
            lat: this.poi.geo.lat
          });
      }
    }
  },
  watch: {
    widgetWidth() {
      // resize map accordingly and center map
      if (this.mapObject) {
        // invalidate size
        this.mapObject.invalidateSize(false);
        // re-center map
        if (this.poi?.geo)
          this.mapObject.panTo({
            lon: this.poi.geo.lng,
            lat: this.poi.geo.lat
          });
      }
    }
  }
};
